import React from "react";
import "../Signup/Signup.scss";
import bgBanner from "../../assets/images/bg-img.svg";
import LogoIcon from "../../assets/images/white_locshark_1.png";
import SignupForm from "./SignupForm";

const Signup = () => {

  return (
    <div className="login-section signup-page">
      <div className="container">
        <div className="row m-0">
          <div className="col-md-4 p-0">
            <div className="sign-bg-banner h-100">
              <img src={bgBanner} className="img-fluid h-100" alt="signup-background" />
              <div className="over-sml-img">
                <img src={LogoIcon} className="img-fluid" alt="signup-logo" />
              </div>
            </div>
          </div>
          <div className="col-md-8 d-flex align-items-center justify-content-center px-0 px-sm-0 px-md-4">
            <div className="create-ac-main-box">
              <h4 className="mt-4">Create Account</h4>
              <SignupForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
